<!--
 * @Author: likk
 * @Date: 2023-09-08 17:34:34
 * @LastEditTime: 2023-09-11 17:11:54
 * @LastEditors: likk
 * @Description: 审核拒绝原因弹框
-->
<template>
  <el-dialog title="不通过理由" :visible.sync="visible" width="430px">
    <el-input type="textarea" :rows="4" placeholder="请输入不通过理由" v-model="content" maxlength="100"></el-input>
    <div class="foot">
      <el-button type="primary" class="btn-gray" @click="handleVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSubmit()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data(){
      return {
        visible:false,
        content:"",
      }
    },
    watch:{
      visible:{
        handler(val){
          val && (this.content='')
        }
      }
    },
    methods:{
      /**
       * @Author: likk
       * @description: 确定
       * @param {*}
       * @return {*}
       */      
      handleSubmit(){
        this.$emit('submit',this.content)
      },
      /**
       * @Author: likk
       * @description: 弹框显示/隐藏状态切换
       * @param {*}
       * @return {*}
       */   
      handleVisible(status){
        this.visible = status;
      }   
    }
  }
</script>

<style lang="scss" scoped>
  .el-dialog{
    .el-textarea{
      font-size: 16px;
    }
    .foot{
      margin-top: 15px;
      text-align: center;
      .el-button{
        font-size: 18px;
        padding: 11px 30px;
        &.btn-gray{
          background: #F2F3F5;
          border-color: #F2F3F5;
          color: #666666;
        }
      }
    }
  }
</style>
